import errorModule from 'src/js/modules/error';
import { serviceProvider } from '@yola/subscription-manager-js';
import status from 'src/js/modules/status';
import statusNames from '../constants/status-names';

const cancelTrial = (subscriptionId, reason) => async (dispatch) => {
  dispatch(status.actions.setStatus(statusNames.CANCEL_TRIAL, status.constants.LOADING));

  try {
    await serviceProvider.cancelTrial(subscriptionId, reason);
    dispatch(status.actions.setStatus(statusNames.CANCEL_TRIAL, status.constants.SUCCEEDED));
  } catch (error) {
    errorModule.operations.catchError(error);
    console.error(error);
    dispatch(status.actions.setStatus(statusNames.CANCEL_TRIAL, status.constants.FAILED));

    throw error;
  }
};

export default cancelTrial;
